export const SIGN_IN = 'auth/SIGN_IN';
export const SIGN_IN_SUCCESS = 'auth/SIGN_IN_SUCCESS';
export const SIGN_IN_FAILED = 'auth/SIGN_IN_FAILED';
export const LOGOUT = 'auth/LOGOUT';
